const {
  isPlainObject
} = require('lodash');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate typedContentBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  let result;
  const input = await evaluateSource(source.source, content, parentContentPath, transientContext, nativeFunctions);
  if (typeof input === 'boolean') {
    result = {
      booleanValue: input
    };
  } else if (typeof input === 'number') {
    result = {
      numberValue: input
    };
  } else if (typeof input === 'string') {
    result = {
      stringValue: input
    };
  } else if (isPlainObject(input)) {
    result = {
      objectValue: input
    };
  }
  return result;
};
module.exports = {
  evaluate
};